import gql from 'graphql-tag';

export const GetPresignedSignatureUrl = gql`
  query getPresignedSignatureUrl {
    getPresignedSignatureUrl {
      url
      key
    }
  }
`;
